module.exports = __webpack_public_path__ + "static/card-two-dee144e7afc9c3f76498622ef5e4527d.jpg";